// noinspection ES6UnusedImports
import * as React from 'preact/compat'
import { hideToast, type ToastConfig } from './index'
import cn from 'classnames'
import commonCss from '../../../css/common.pcss.json'
import { useSignal } from '@preact/signals'
import { useCallback, useEffect, useRef } from 'preact/compat'

export default ({
  config
}: {
  config: ToastConfig
}) => {
  if (!config.timeout && config.timeout !== 0) {
    config.timeout = 4000
  }
  const animationDuration = 500
  const timer = useSignal<number>(config.timeout)
  const isShown = useSignal<boolean>(false)
  const interval = useRef<number>()
  const resetTimer = useCallback(() => {
    clearInterval(interval.current)
    timer.value = config.timeout
  }, [interval.current, timer.value])
  const hideSelf = useCallback(() => {
    clearInterval(interval.current)
    isShown.value = false
    setTimeout(() => {
      hideToast(config.uuid)
    }, animationDuration)
  }, [interval.current, isShown.value, config.uuid])
  const startTimer = useCallback(() => {
    if (config.timeout === 0) {
      return
    }
    interval.current = setInterval(() => {
      timer.value -= 100
      if (timer.value <= 0) {
        hideSelf()
      }
    }, 100) as unknown as number
  }, [interval.current, timer.value, config.timeout])
  const percentage = config.timeout === 0 ? 0 : timer.value / config.timeout * 100

  useEffect(() => {
    isShown.value = true
    timer.value = config.timeout
    setTimeout(() => {
      startTimer()
    }, animationDuration)
  }, [config.timeout])

  return <div
    className={cn(commonCss['toast'], commonCss[`toast--type-${config.type}`], {
      [commonCss['toast--shown']]: isShown.value,
    })}
    onMouseOver={resetTimer}
    onMouseLeave={startTimer}
    onClick={hideSelf}
  >
    <div className={commonCss['toast__content']} dangerouslySetInnerHTML={{__html: config.text}}/>
    <div className={commonCss['toast__timer']} style={{width: `${percentage}%`}}/>
  </div>
}
